export default "__VITE_ASSET__CXYtIEaK__"